import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from 'recharts';

const Chart = ({ interval, data }) => (
  <ResponsiveContainer height={400} width="100%">
    <LineChart data={data} margin={{ right: 25, top: 10 }}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="month" interval={interval} />
      <YAxis interval={interval} />
      <Line type="monotone" dataKey="member_count" stroke="#8884d8" activeDot={{ r: 8 }} />
    </LineChart>
  </ResponsiveContainer>
);

const Graph = ({ data }) => (
  <>
    {data && <Chart interval="preserveEnd" data={data} />}
  </>
);

export default Graph;